<template>
    <div class="step-delivery-data">

        <div class="limit-wrap-buttons">

            <div class="pick-buttons">
                <icon-text-checkbox v-on:input="handleMethodClick(true)" :value="enterNowChecked">
                    <template v-slot:image>
                        <img src="../../assets/icon_pencil.png"/>
                    </template>
                    <template v-slot:label>
                        Uzupełnij teraz
                    </template>
                </icon-text-checkbox>

                <icon-text-checkbox v-on:input="handleMethodClick(false)" :value="enterLaterChecked">
                    <template v-slot:image>
                        <img src="../../assets/icon_clock.png"/>
                    </template>
                    <template v-slot:label>
                        Uzupełnij później
                    </template>
                </icon-text-checkbox>
            </div>

        </div>

        <form v-on:submit.prevent="submit">
            <div v-if="enterNowChecked" class="limit-wrap">
                <h4>Uzupełnij adres teraz:</h4>
                <div class="form-row">
                    <input-group v-model="form.street" :val="form.street" :valid="errors.street" class-name="street"
                                 name="street" placeholder="Ulica">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>
                </div>
                <div class="form-row street-house">
                    <input-group v-model="form.houseNumber" :val="form.houseNumber" :valid="errors.houseNumber"
                                 type="short-label" class="street-name detached-error" name="street_name"
                                 placeholder="Numer domu">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>

                    <input-group v-model="form.apartmentNumber" :val="form.apartmentNumber"
                                 :valid="errors.apartmentNumber" type="short-label" class="house-number detached-error"
                                 name="house_number" placeholder="Numer mieszkania">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>
                </div>

                <div class="form-row half-half">
                    <input-group v-model="form.city" :val="form.city" :valid="errors.city" name="city"
                                 placeholder="Miasto">
                        <template v-slot:errorMessage>Wypełnij to pole</template>
                    </input-group>


                    <input-group v-model="form.country" :val="form.country" :valid="errors.country" name="country"
                                 type="select" :options="getCountries()">
                        <template v-slot:errorMessage>Wybierz kraj</template>
                    </input-group>
                </div>

                <div class="date form-row">
                    <input-group v-model="form.postal" :val="form.postal" :valid="errors.postal" type="postal"
                                 class="detached-error">
                        <template v-slot:errorMessage>Podaj poprawny kod pocztowy</template>
                    </input-group>
                </div>
            </div>

            <div class="info">
                <h4>To już prawie koniec rejestracji.</h4>
                Zapisz konto i kliknij link aktywacyjny, który wyślemy na Twój adres mailowy.
            </div>

            <spacer />

            <div class="navigation">
                <button v-on:click="goBack" type="button" class="go-back-button"></button>
                <button type="submit" class="submit-purple-button">Zapisz profil</button>
            </div>

        </form>

    </div>
</template>

<script>
    import InputGroup from "./elements/InputGroup";
    import IconTextCheckbox from "./elements/IconTextCheckbox";
    import countries from '../../assets/countries.json';
    import Spacer from "../Spacer";

    export default {
        name: "StepDeliveryData",
        components: {Spacer, IconTextCheckbox, InputGroup},
        props: ['form'],
        data() {
            return {
                enterNowChecked: false,
                enterLaterChecked: false,
                errors: {
                    street: true,
                    houseNumber: true,
                    city: true,
                    country: true,
                    postal: true
                }
            }
        },
        methods: {
            submit: function () {
                if (!this.enterNowChecked && !this.enterLaterChecked) {
                    this.$notify({
                        group: 'form',
                        type: 'warn',
                        title: 'Wybierz jedną z opcji'
                    });

                    return;
                }

                if(this.enterLaterChecked) {
                    this.$emit('submit-data', false);
                    return;
                }

                this.fullValidate();

                let isValid = this.formIsValid();

                if(isValid === true) {
                    this.$emit('submit-data', this.form);
                }
                else {
                    this.$notify({
                        group: 'form',
                        type: 'warn',
                        title: 'Formularz zawiera błędy'
                    });
                }
            },
            goBack: function () {
                this.$emit('go-back');
            },
            handleMethodClick(data) {

                if (data) {
                    if (this.enterNowChecked) {
                        this.enterNowChecked = false;
                        this.enterLaterChecked = false;
                    }
                    else {
                        this.enterNowChecked = true;
                        this.enterLaterChecked = false;
                    }
                }
                else {
                    if (this.enterLaterChecked) {
                        this.enterNowChecked = false;
                        this.enterLaterChecked = false;
                    }
                    else {
                        this.enterNowChecked = false;
                        this.enterLaterChecked = true;
                    }
                }
            },
            getCountries: function () {
                let result = [];

                result.push({
                    label: 'Kraj',
                    value: ''
                });

                for (let i = 0; i < countries.length; i++) {
                    result.push({
                        label: countries[i],
                        value: countries[i]
                    });
                }

                return result;
            },
            validateLength: function (value, lengthMin, lengthMax) {
                if (value.length < lengthMin) return false;
                if (value.length > lengthMax) return false;

                return true;
            },
            formIsValid: function () {
                if (!this.errors.street) return false;
                if (!this.errors.houseNumber) return false;
                if (!this.errors.city) return false;
                if (!this.errors.country) return false;
                if (!this.errors.postal) return false;

                return true;
            },
            fullValidate: function () {
                this.errors.street = this.validateLength(this.form.street, 1);
                this.errors.houseNumber = this.validateLength(this.form.houseNumber, 1);
                this.errors.city = this.validateLength(this.form.city, 1);
                this.errors.country = this.validateLength(this.form.country, 1);
                this.errors.postal = this.validateLength(this.form.postal.prefix, 2, 2);
                if(this.errors.postal) {
                    this.errors.postal = this.validateLength(this.form.postal.suffix, 3, 3);
                }
            },
            triggerResize() {
                this.$nextTick(function () {
                    var resizeEvent = window.document.createEvent('UIEvents');
                    resizeEvent .initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(resizeEvent);
                });
            }
        },
        watch: {
            enterNowChecked: function () {
                this.triggerResize();
            },
            enterLaterChecked: function () {
                this.triggerResize();
            },
            'form.street': function () {
                this.errors.street = true;
                this.errors.street = this.validateLength(this.form.street, 1);
            },
            'form.houseNumber': function () {
                this.errors.houseNumber = true;
                this.errors.houseNumber = this.validateLength(this.form.houseNumber, 1);
            },
            'form.city': function () {
                this.errors.city = true;
                this.errors.city = this.validateLength(this.form.city, 1);
            },
            'form.country': function () {
                this.errors.country = true;
                this.errors.country = this.validateLength(this.form.country, 1);
            },
            'form.postal.prefix': function () {
                this.errors.postal = true;
            },
            'form.postal.suffix': function () {
                this.errors.postal = true;
            }
        }
    }
</script>

<style scoped lang="scss">

</style>